import styled from 'styled-components';
import HeroImage from 'assets/Ohio_Figma.jpg';
import DetourIcon from 'assets/icons/Detour_Landing.svg';
import { CalciteH1, CalciteH2 } from 'calcite-react/Elements';

const StyledHero = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 85vh;
  min-height: 80vh;
  width: 100%;
  background-image: url(${() => HeroImage}),
    linear-gradient(350deg, rgba(145, 145, 145, 0.2) 10%, rgba(28, 28, 28, 0.6) 30.98%, rgba(28, 28, 28, 0.9) 80.98%);
  background-attachment: fixed;
  background-repeat: round;
  background-blend-mode: overlay;
`;

const StyledUser = styled.div`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  width: 500px;
  text-align: right;
`;

const StyledSubmitFeedback = styled.div`
  position: relative;
  top: 1rem;
`;

const StyledLogo = styled.div`
  margin-top: 1.6rem;
  margin-left: 2rem;
  height: 96px;
  min-height: 96px;
  width: 96px;
  background-image: url(${() => DetourIcon});
  background-repeat: no-repeat;
`;

const StyledHeaderContainer = styled.section`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 10%;
`;

const StyledUserSignUpLogin = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  margin-top: 0.5rem;
`;

const StyledCalciteH1 = styled(CalciteH1)`
  font-family: ${({ theme }) => theme.type.accentFamily};
  color: white;
  font-size: 5rem;
  font-weight: bold;
  line-height: 5rem;
  @media (max-width: 575px) {
    font-size: 3rem;
    line-height: 3rem;
  }
`;

const StyledCalciteH2 = styled(CalciteH2)`
  font-weight: bold;
  color: ${({ theme }) => theme.palette.white};
  text-shadow: 0 0 3px ${({ theme }) => theme.palette.themeColor};
  font-size: 2.5rem;
  font-family: ${({ theme }) => theme.type.accentFamily};
  @media (max-width: 575px) {
    font-size: 1.5rem;
    line-height: 1.5rem;
  }
`;

const StyledHeroContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 0 2 auto;
  flex-direction: column;
  width: 30rem;
  padding: 2rem 0.1rem;
  color: black;
  @media (max-width: 575px) {
    margin: 0 1rem;
    width: inherit;
  }
  border-radius: 25px;
`;

const StyledWhereToContainer = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  top: 4rem;
  height: 60%;
  justify-content: center;
  align-items: center;
`;

export {
  StyledHero,
  StyledUser,
  StyledCalciteH1,
  StyledCalciteH2,
  StyledHeroContainer,
  StyledHeaderContainer,
  StyledLogo,
  StyledUserSignUpLogin,
  StyledWhereToContainer,
  StyledSubmitFeedback,
};
